import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GhgSuperdashboardState } from './slice.types';
import { OrganizationSchema } from 'src/utils/api.interfaces';

const initialState: GhgSuperdashboardState = {
  selectedCompanies: [],
  selectedBranches: [],
  selectedTimeRange: {
    start: null,
    end: null,
  },
};

interface SetSelectedBranchesPayload {
  organizations: OrganizationSchema[];
  selectedBranches: string[];
}

const ghgSuperdashboardSlice = createSlice({
  name: 'ghg-superdashboard',
  initialState,
  reducers: {
    setSelectedCompanies: (state, action: PayloadAction<number[]>) => {
      state.selectedCompanies = action.payload;
      state.selectedBranches = [];
    },
    setSelectedBranches: (
      state,
      action: PayloadAction<SetSelectedBranchesPayload>
    ) => {
      state.selectedCompanies = action.payload.organizations
        .filter((org) =>
          action.payload.selectedBranches.some((branch) =>
            org.branches.includes(branch)
          )
        )
        .map((org) => org.id);
      state.selectedBranches = action.payload.selectedBranches;
    },
  },
});

export const { setSelectedCompanies, setSelectedBranches } =
  ghgSuperdashboardSlice.actions;

export default ghgSuperdashboardSlice.reducer;
